import { http } from "./http";
import qs from "qs";

async function getPhasesRoutePlanning(filter) {
  const response = await http.get("route-planning", {
    params: filter,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return response.data.map(item => {
    return {
      ariveToWarehouseDate: item.ArriveToWarehouseDate
        ? { plan: item.ArriveToWarehouseDate.Plan, fact: item.ArriveToWarehouseDate.Fact }
        : null,
      carLoadingDate: item.CarLoadingDate
        ? { plan: item.CarLoadingDate.Plan, fact: item.CarLoadingDate.Fact }
        : null,
      city: item.City ? { id: item.City.Id, title: item.City.Title } : null,
      deliveryToUnloadingPlaceDate: item.DeliveryToUnloadingPlaceDate,
      direction: item.Direction ? { id: item.Direction.Id, title: item.Direction.Title, prefix: item.Direction.Prefix } : null,
      district: item.District ? { id: item.District.Id, title: item.District.Title } : null,
      inCar: item.InCar,
      loadingPlace: {
        warehouse: item.LoadingPlace.Warehouse ? { id: item.LoadingPlace.Warehouse.Id, title: item.LoadingPlace.Warehouse.Title } : null,
        factory: item.LoadingPlace.Factory ? { id: item.LoadingPlace.Factory.Id, title: item.LoadingPlace.Factory.Title } : null,
        address: item.LoadingPlace.Address ? { id: item.LoadingPlace.Address.Id, title: item.LoadingPlace.Address.Title } : null,
      },
      phaseId: item.PhaseId,
      phaseType: { id: item.PhaseType.Id, title: item.PhaseType.Title },
      postcode: item.Postcode,
      readyDate: item.ReadyDate,
      region: { id: item.Region.Id, title: item.Region.Title },
      route: item.Route ? { id: item.Route.Id, title: item.Route.Title } : null,
      sender: item.Sender,
      shipping: { id: item.Shipping.Id, title: item.Shipping.Title },
      volume: item.Volume,
      warehouse: {
        warehouse: item.Warehouse.Warehouse ? { id: item.Warehouse.Warehouse.Id, title: item.Warehouse.Warehouse.Title } : null,
        factory: item.Warehouse.Factory ? { id: item.Warehouse.Factory.Id, title: item.Warehouse.Factory.Title } : null,
        address: item.Warehouse.Address ? { id: item.Warehouse.Address.Id, title: item.Warehouse.Address.Title } : null,
      },
      warehouseType: item.WarehouseType,
      weight: item.Weight,
      client: item.Client ? { id: item.Client.Id, title: item.Client.Title } : null,
      clientAlias: item.ClientAlias,
      isFamiliarized: item.IsFamiliarized,
      cargoPlaces: item.CargoPlaces,
      loadingNumber: item.LoadingNumber,
      productDescription: item.ProductDescription,
      factoryClosingDate: item.FactoryClosingDate || null,
      cargoComment: item.CargoComment || null,
    };
  });
}

async function getDefaultCountry() {
  const response = await http.get("countries/ukraine");
  return response;
}

async function createRoute(draftId, directionId, shippings) {
  const response = await http.post("routes/by-plan", {
    draftId,
    directionId,
    items: shippings.map(s => {
      return {
        shippingId: s.shipping.id,
        phaseId: s.phaseId,
      };
    }),
  });
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function getDrafts() {
  const response = await http.get("route-planning/drafts");
  return response.data.map(i => {
    return {
      id: i.Id,
      title: i.Number,
      direction: i.Direction ? { id: i.Direction.Id, title: i.Direction.Title } : null,
      phases: i.Shippings.map(item => {
        return {
          ariveToWarehouseDate: item.ArriveToWarehouseDate
            ? { plan: item.ArriveToWarehouseDate.Plan, fact: item.ArriveToWarehouseDate.Fact }
            : null,
          carLoadingDate: item.CarLoadingDate
            ? { plan: item.CarLoadingDate.Plan, fact: item.CarLoadingDate.Fact }
            : null,
          city: item.City ? { id: item.City.Id, title: item.City.Title } : null,
          deliveryToUnloadingPlaceDate: item.DeliveryToUnloadingPlaceDate,
          direction: item.Direction ? { id: item.Direction.Id, title: item.Direction.Title, prefix: item.Direction.Prefix } : null,
          district: item.District ? { id: item.District.Id, title: item.District.Title } : null,
          inCar: item.InCar,
          loadingPlace: item.LoadingPlace.Warehouse ? item.LoadingPlace.Warehouse.Title
            : item.LoadingPlace.Factory ? item.LoadingPlace.Factory.Title
              : item.LoadingPlace.Address ? item.LoadingPlace.Address.Title
                : null,
          phaseId: item.PhaseId,
          phaseType: { id: item.PhaseType.Id, title: item.PhaseType.Title },
          postcode: item.Postcode,
          readyDate: item.ReadyDate,
          region: { id: item.Region.Id, title: item.Region.Title },
          route: item.Route ? { id: item.Route.Id, title: item.Route.Title } : null,
          sender: item.Sender,
          shipping: { id: item.Shipping.Id, title: item.Shipping.Title },
          volume: item.Volume,
          warehouse: item.Warehouse.Warehouse ? item.Warehouse.Warehouse.Title
            : item.Warehouse.Factory ? item.Warehouse.Factory.Title
              : item.Warehouse.Address ? item.Warehouse.Address.Title
                : null,
          warehouseType: item.WarehouseType,
          weight: item.Weight,
          client: item.Client ? { id: item.Client.Id, title: item.Client.Title } : null,
          clientAlias: item.ClientAlias,
          isFamiliarized: item.IsFamiliarized,
          cargoPlaces: item.CargoPlaces,
          loadingNumber: item.LoadingNumber,
          productDescription: item.ProductDescription,
          draft: { id: i.Id, title: i.Number },
        };
      }),
    };
  });
}

async function createRouteDraft(shippingId, phaseId, directionId) {
  const response = await http.post("route-planning/drafts", {
    shippingId,
    phaseId,
    directionId,
  });
  return {
    id: response.data.Id,
    number: response.data.Number,
  };
}

async function deleteRouteDraft(id) {
  const response = await http.delete(`route-planning/${id}/drafts`);
  return response;
}

async function updateRouteDraft(id, phaseId) {
  const response = await http.patch(`route-planning/drafts/${id}/add-phase`, { value: phaseId });
  return response;
}

async function deleteShippingFromRouteDraft(id, phaseId) {
  const response = await http.patch(`route-planning/drafts/${id}/remove-phase`, { value: phaseId });
  return response;
}

async function getRoutes() {
  const response = await http.get("route-planning/routes");
  return response.data.map(i => {
    return {
      id: i.Id,
      title: i.Number,
      direction: i.Direction ? { id: i.Direction.Id, title: i.Direction.Title } : null,
      logist: i.Logist ? { id: i.Logist.Id, title: i.Logist.Title } : null,
      phases: i.Shippings.map(item => {
        return {
          ariveToWarehouseDate: item.ArriveToWarehouseDate
            ? { plan: item.ArriveToWarehouseDate.Plan, fact: item.ArriveToWarehouseDate.Fact }
            : null,
          carLoadingDate: item.CarLoadingDate
            ? { plan: item.CarLoadingDate.Plan, fact: item.CarLoadingDate.Fact }
            : null,
          city: item.City ? { id: item.City.Id, title: item.City.Title } : null,
          deliveryToUnloadingPlaceDate: item.DeliveryToUnloadingPlaceDate,
          direction: item.Direction ? { id: item.Direction.Id, title: item.Direction.Title, prefix: item.Direction.Prefix } : null,
          district: item.District ? { id: item.District.Id, title: item.District.Title } : null,
          inCar: item.InCar,
          loadingPlace: item.LoadingPlace.Warehouse ? item.LoadingPlace.Warehouse.Title
            : item.LoadingPlace.Factory ? item.LoadingPlace.Factory.Title
              : item.LoadingPlace.Address ? item.LoadingPlace.Address.Title
                : null,
          phaseId: item.PhaseId,
          phaseType: { id: item.PhaseType.Id, title: item.PhaseType.Title },
          postcode: item.Postcode,
          readyDate: item.ReadyDate,
          region: { id: item.Region.Id, title: item.Region.Title },
          route: item.Route ? { id: item.Route.Id, title: item.Route.Title } : null,
          sender: item.Sender,
          shipping: { id: item.Shipping.Id, title: item.Shipping.Title },
          volume: item.Volume,
          warehouse: item.Warehouse.Warehouse ? item.Warehouse.Warehouse.Title
            : item.Warehouse.Factory ? item.Warehouse.Factory.Title
              : item.Warehouse.Address ? item.Warehouse.Address.Title
                : null,
          warehouseType: item.WarehouseType,
          weight: item.Weight,
          client: item.Client ? { id: item.Client.Id, title: item.Client.Title } : null,
          clientAlias: item.ClientAlias,
          isFamiliarized: item.IsFamiliarized,
          cargoPlaces: item.CargoPlaces,
          loadingNumber: item.LoadingNumber,
          productDescription: item.ProductDescription,
          routeItemId: item.RouteItemId,
          hasUnreadNotes: item.HasUnreadNotes,
          factoryClosingDate: item.FactoryClosingDate || null,
          isFirstInRoutePhase: item.IsFirstInRoutePhase,
        };
      }),
    };
  });
}

async function getItemFamiliarized(phaseId) {
  const response = await http.get(`route-planning/phases/${phaseId}/familiarized`);
  return response.data ? {
    user: response.data.User,
    date: response.data.Date,
  } : null;
}

async function changeShippingPhaseFamiliarized(phaseId) {
  const response = await http.patch(`route-planning/phases/${phaseId}/familiarized`);
  return response;
}

async function changeFactoryClosingDate(phaseId, factoryClosingDate) {
  const response = await http.patch(`route-planning/phase/${phaseId}/factory-closing-date`, { value: factoryClosingDate });
  return response;
}

export {
  getPhasesRoutePlanning,
  getItemFamiliarized,
  getDefaultCountry,
  createRoute,
  getDrafts,
  createRouteDraft,
  deleteRouteDraft,
  updateRouteDraft,
  deleteShippingFromRouteDraft,
  getRoutes,
  changeShippingPhaseFamiliarized,
  changeFactoryClosingDate,
};